import React from "react";

const SimplePagination = ({
  totalPages,
  currentPage,
  onPageChange,
  limit,
  onLimitChange,
  totalItems,
}) => {
  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handleLimitChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    if (!isNaN(newLimit) && newLimit > 0) {
      onLimitChange(newLimit);
    }
  };

  return (
    <div className="flex flex-col sm:flex-row justify-between items-center bg-gray-100 shadow-md rounded-md p-4">
      <div className="flex items-center mb-4 sm:mb-0">
        <span className="text-sm font-medium mr-2 text-gray-600">
          Items per page:
        </span>
        <select
          value={limit}
          onChange={handleLimitChange}
          className="border border-gray-300 rounded-md p-2 w-24 bg-white"
        >
          <option value={10}>10</option>
          <option value={25}>25</option>
          <option value={100}>100</option>
        </select>
      </div>
      <div className="flex justify-center items-center">
        <button
          onClick={handlePrevious}
          disabled={currentPage === 1}
          className={`px-4 py-2 transition-colors ${
            currentPage === 1
              ? "text-gray-400 dark:text-gray-500"
              : "text-[--primary]"
          }`}
        >
          Previous
        </button>
        <span className="px-4 py-2 bg-[--primary] text-white rounded-md mx-2">
          {currentPage}
        </span>
        <button
          onClick={handleNext}
          disabled={currentPage === totalPages}
          className={`px-4 py-2 transition-colors ${
            currentPage === totalPages
              ? "text-gray-400 dark:text-gray-500"
              : "text-[--primary]"
          }`}
        >
          Next
        </button>
      </div>
      <div className="mt-4 text-sm text-gray-600 ">
        Showing {Math.min((currentPage - 1) * limit + 1, totalItems)} to{" "}
        {Math.min(currentPage * limit, totalItems)} of {totalItems} items
      </div>
      <div className="mt-2 text-sm text-gray-600 ">
        Total Pages: {totalPages}
      </div>
    </div>
  );
};

export default SimplePagination;
